import { Link } from 'react-router';
import { Bouton } from '../shared/ui/Bouton';
import { Paragraphe, Section } from '../shared/ui/Section';
import { Titre } from '../shared/ui/Titre';

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * **PAGE 8 DES HUIT — LA PAGE SUR LE GROUPE.**
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * F-69 la liste sans rien exiger de son contenu — la table porte « — » dans sa colonne de
 * caractérisation, et le brief de maquette la nomme S-21, également sans contenu imposé :
 * « le texte de chaque page, son titre, l'ordre de ses sections et la forme de la navigation
 * **ne se posent pas ici** : ils se fabriquent dans l'outil de maquettage. »
 *
 * **CE QUI EST IMPOSÉ, EN REVANCHE, EST CE QU'ELLE NE PEUT PAS PORTER**, et trois règles
 * l'atteignent :
 *
 * - **aucune citation attribuée à une personne nommée** (F-74) : « jamais au nom d'une
 *   personne, **avec son prénom, sa fonction ou son visage**. Motif : une citation nominative
 *   sur une page publique est une **donnée personnelle publiée**, et le produit ne recueille
 *   aucun accord d'une personne pour cela. » **C'est la page où la tentation est la plus
 *   forte** — une page « sur le groupe » appelle une équipe, des visages et des titres. Elle
 *   n'en porte aucun, et ce n'est pas un manque de matière ;
 * - **aucun chiffre calculé sur les données du produit** (F-74), donc aucun « X élèves
 *   accompagnés » : les seuls chiffres du site sont les valeurs saisies des marques, sur
 *   l'accueil ;
 * - **elle est dans le pied de page ET dans le menu**, F-69 : le pied « porte le chemin vers
 *   la page juridique, **la page du groupe** et l'adresse email affichée ». Elle est la seule
 *   des huit à figurer aux deux endroits.
 */
export function PageGroupe() {
  return (
    <>
      <Section largeur="etroite">
        <Titre niveau={1}>Le groupe</Titre>
        <Paragraphe>
          Swype est édité par le Groupe Trousseau, qui construit et exploite ses
          propres outils pour le soutien scolaire.
        </Paragraphe>
      </Section>

      <Section largeur="etroite" titre="Pourquoi ce produit existe">
        <Paragraphe>
          Les cours à distance se donnent souvent en partageant un écran, ce qui
          ne permet pas d’écrire à la main devant quelqu’un. Or une
          démonstration de mathématiques, une correction de dictée ou un schéma
          se font au crayon. Swype part de là : le tableau d’abord, le reste
          autour.
        </Paragraphe>
      </Section>

      <Section largeur="etroite" titre="Ce que le groupe s’interdit">
        <Paragraphe>
          Swype ne facture aucune famille et n’écrit à aucune. Il ne mesure pas
          l’audience de ce site, ne dépose pas d’identifiant de suivi, et ne
          publie aucune image réelle d’un cours — donc aucune écriture, aucun
          prénom, aucun travail d’élève.
        </Paragraphe>
        <Paragraphe>
          Les structures clientes nommées sur l’accueil l’ont accepté par écrit,
          en dehors du produit. Aucune n’y figure sans avoir donné son accord, et
          aucune personne n’y est citée.
        </Paragraphe>
      </Section>

      <Section largeur="etroite" titre="Où vivent les données">
        <Paragraphe>
          L’hébergement et les outils du groupe sont en Union européenne, avec
          une seule exception, datée et limitée au service de visioconférence.
          Le détail est porté par les mentions légales.
        </Paragraphe>
        <div className="flex flex-wrap gap-3">
          <Link to="/mentions-legales">
            <Bouton variante="faible">Mentions légales</Bouton>
          </Link>
          <Link to="/contact">
            <Bouton>Nous écrire</Bouton>
          </Link>
        </div>
      </Section>
    </>
  );
}
